__turbopack_context__.v({
  "cardContent": "fullBgCard-module-scss-module__Xaau5W__cardContent",
  "cardLink": "fullBgCard-module-scss-module__Xaau5W__cardLink",
  "cardTitle": "fullBgCard-module-scss-module__Xaau5W__cardTitle",
  "contentWrapper": "fullBgCard-module-scss-module__Xaau5W__contentWrapper",
  "contentWrapperFull": "fullBgCard-module-scss-module__Xaau5W__contentWrapperFull",
  "contentWrapperLeft": "fullBgCard-module-scss-module__Xaau5W__contentWrapperLeft",
  "contentWrapperRight": "fullBgCard-module-scss-module__Xaau5W__contentWrapperRight",
  "desktopImage": "fullBgCard-module-scss-module__Xaau5W__desktopImage",
  "imageBlock": "fullBgCard-module-scss-module__Xaau5W__imageBlock",
  "mobileImage": "fullBgCard-module-scss-module__Xaau5W__mobileImage",
  "submitBtn": "fullBgCard-module-scss-module__Xaau5W__submitBtn",
  "wrapper": "fullBgCard-module-scss-module__Xaau5W__wrapper",
  "wrapperBackground": "fullBgCard-module-scss-module__Xaau5W__wrapperBackground",
  "wrapperBackgroundHidden": "fullBgCard-module-scss-module__Xaau5W__wrapperBackgroundHidden",
});
